import { Tag } from "antd";
import { SYNC_ROW_TAG_CONFIG } from "./constants";
import ExpandableValue from "./ExpandableValue";

const TYPE_MISMATCH_TYPES = ["type_mismatch", "value_and_type_mismatch"];

const getValue = (record, side) => {
  if (record.category === "only_in_dev") {
    return side === "dev" ? record.item?.name || record.id : "—";
  }

  if (record.category === "only_in_prod") {
    return side === "prod" ? record.item?.name || record.id : "—";
  }

  if (record.difference_type === "list_membership_mismatch") {
    const items = record[`only_in_${side}`] || [];
    if (items.length === 0) return "—";
    return items.map(({ item, count }) => `${item} (${count})`).join(", ");
  }

  return TYPE_MISMATCH_TYPES.includes(record.difference_type)
    ? `${record[side]} (${record[`${side}_type`]})`
    : String(record[side]);
};

const renderValue = (record, side, expandedRowKeys, onToggleExpand) => (
  <ExpandableValue
    value={getValue(record, side)}
    expanded={expandedRowKeys.includes(record.rowKey)}
    onToggle={() => onToggleExpand(record.rowKey)}
  />
);

export const getSyncColumns = ({ expandedRowKeys, onToggleExpand }) => [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: "6%",
  },
  {
    title: "Campo",
    dataIndex: "field",
    key: "field",
    width: "14%",
  },
  {
    title: "Tipo",
    key: "type",
    width: "12%",
    render: (_, record) => {
      const config = SYNC_ROW_TAG_CONFIG[record.category];
      return <Tag style={config}>{config.label}</Tag>;
    },
  },
  {
    title: "Valor em Dev",
    key: "devValue",
    width: "34%",
    render: (_, record) =>
      renderValue(record, "dev", expandedRowKeys, onToggleExpand),
  },
  {
    title: "Valor em Prod",
    key: "prodValue",
    width: "34%",
    render: (_, record) =>
      renderValue(record, "prod", expandedRowKeys, onToggleExpand),
  },
];
